import { Quote } from "lucide-react";
import MotionSection from "../common/MotionSection";
import SectionHeading from "../common/SectionHeading";
import { aboutPageData } from "../../data/aboutData";

function AboutFounder() {
  const { founders } = aboutPageData;
  const isSingleFounder = founders.length === 1;
  const accentClasses = [
    "from-royal-blue/15 to-sky-glow/60",
    "from-warm-gold/20 to-sky-glow/60"
  ];

  return (
    <MotionSection className="py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-6">
        <SectionHeading
          kicker={isSingleFounder ? "Founder" : "Founding Team"}
          title={
            isSingleFounder
              ? "Leadership Built on Clarity, Trust, and Student Success"
              : "Founders, One Shared Promise"
          }
          description="Every student receives thoughtful guidance shaped by strategic expertise and personal mentorship."
        />

        <div
          className={`mt-10 ${isSingleFounder ? "flex justify-center" : "grid gap-5 md:grid-cols-2"}`}
        >
          {founders.map((founder, index) => (
            <article
              key={founder.name}
              className={`signature-card overflow-hidden rounded-[1.8rem] ${
                isSingleFounder ? "w-full max-w-3xl" : ""
              }`}
            >
              <div className={`bg-gradient-to-r px-6 py-5 ${accentClasses[index % accentClasses.length]}`}>
                <div className="flex items-center gap-4">
                  <span className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-midnight-navy text-lg font-bold text-soft-white">
                    {founder.initials}
                  </span>
                  <div>
                    <p className="text-xs font-semibold uppercase tracking-[0.16em] text-royal-blue">
                      {founder.title}
                    </p>
                    <h3 className="mt-1 text-2xl leading-tight text-midnight-navy">{founder.name}</h3>
                  </div>
                </div>
              </div>

              <div className="p-6">
                <div className="flex items-start gap-2">
                  <Quote className="mt-0.5 h-4 w-4 text-royal-blue" aria-hidden="true" />
                  <p className="text-sm leading-relaxed text-slate-text/85 md:text-base">{founder.bio}</p>
                </div>

                <p className="mt-5 rounded-xl bg-sky-glow/70 px-4 py-3 text-sm font-medium text-midnight-navy">
                  Focus Area: {founder.focus}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </MotionSection>
  );
}

export default AboutFounder;
